

import React from "react";

const PrivacyPolicy = () => {
  return (
    <section className="container mx-auto px-4 py-12">
      <h1 className="text-3xl font-semibold mb-4">Privacy Policy</h1>
      <p className="text-gray-700">Details about privacy policy will go here.</p>
    </section>
  );
};

export default PrivacyPolicy;
